export const miKuKzRouter = [
    {
        path: "/",
        name: "Home",
        component: () => import(/* webpackChunkName: "H" */ "../pages/Home"),
    },
    {
        path: "/p/:slug/:offer?",
        name: "Product",
        component: () => import(/* webpackChunkName: "Prdc" */ "../pages/Product"),
        props: (route) => ({
            slug: route.params.slug,
            offer: route.params.offer,
        }),
    },
    {
        path: "/p-garantiya",
        name: "Guarantee",
        component: () => import(/* webpackChunkName: "G" */ "../pages/Guarantee"),
    },
    {
        path: "/p-dostavka-i-oplata",
        name: "Payment",
        component: () => import(/* webpackChunkName: "Pay" */ "../pages/Payment"),
    },
    {
        path: "/thermoses",
        name: "Thermoses",
        component: () => import(/* webpackChunkName: "Thrm" */ "../pages/Thermoses"),
    },
    {
        path: "/microwave-kitchen",
        name: "MicrowaveKitchen",
        component: () => import(/* webpackChunkName: "MWK" */ "../pages/MicrowaveKitchen"),
    },
    {
        path: "/recipes",
        name: "Recipes",
        component: () => import(/* webpackChunkName: "B" */ "../pages/Recipes"),
    },
    {
        path: "/recipes/:slug",
        name: "RecipeDetail",
        component: () => import(/* webpackChunkName: "B_D" */ "../pages/RecipeDetail"),
        props: (route) => ({
            slug: route.params.slug,
        }),
    },
    {
        path: "/blog",
        redirect: "/recipes",
    },
    {
        path: "/blog/:slug",
        redirect: "/recipes/:slug",
    },
    {
        path: "/document-personal",
        name: "DocumentConfidentiality",
        component: () =>
            import(/* webpackChunkName: "Doc" */ "@/pages/DocumentConfidentiality"),
    },
    {
        path: "/document-confidentiality",
        name: "DocumentConfidentiality",
        component: () =>
            import(/* webpackChunkName: "Doc" */ "@/pages/DocumentConfidentiality"),
    },
];
